module.exports = __webpack_public_path__ + "img/llj.3f5cad5f.svg";